<div class="cookie-law">
  <div class="cookie-law--main">
    <div id="cookie-law--message">{ $_('cookie-law.message', 'Wir verwenden Cookies, damit die Webseite korrekt funktioniert.') }</div>
  </div>

  <div class="cookie-law--config pt-1">
    <input class="normal" type="checkbox" disabled={true} checked={true} name="cookie-law--cookies--essential">
    <label for="cookie-law--cookies--essential">{ $_("cookie-law.cookies.required", "Notwendig") }</label>

    <input class="normal" type="checkbox" name="cookie-law--cookies--statistics" bind:checked={statistics}>
    <label for="cookie-law--cookies--statistics">{ $_("cookie-law.cookies.statistics", "Statistik") }</label>

    <input class="normal" type="checkbox" name="cookie-law--cookies" bind:checked={error}>
    <label for="cookie-law--cookies--statistics">{ $_("cookie-law.cookies.errors", "Fehleranalyse") }</label>
  </div>

  <div class="cookie-law--submit pt-2">
    <a href="#" on:click={submitAndAllowAll}><span id="cookie-law--submit--by-form" class="btn btn-default btn-sm ml-3">{ $_('cookie-law.submit.preferred', 'Empfohlene Einstellungen speichern') }</span></a>
    <a href="#" on:click={submit}><span id="cookie-law--submit--preferred" class="btn btn-cta btn-primary btn-sm ml-3" role="co$_law$_submit">{ $_('cookie-law.submit.by-form', 'Einstellungen speichern') }</span></a>
  </div>
</div>

<script>
    import { createEventDispatcher } from "svelte";
    import { _ } from "@/frontend/lib/translations";
    export let statistics = true;
    export let error = true;

    const dispatch = createEventDispatcher();

    function submit() {
        dispatch("submit", {
            statistics,
            error
        });
    }

    function submitAndAllowAll() {
        dispatch("submit", {
            statistics: true,
            error: true
        });
    }
</script>
